import { Analytics } from '@gik/core/utils';
import { IAnalyticsProps } from '@gik/core/utils/Analytics';

export function calendarEventMutatedAnalytics(
  analyticsEventName: 'eventCreated' | 'eventUpdated',
  eventId: string,
  allDay: boolean,
  startsAt: string,
  endsAt: string,
  repeat: string,
  eventDescription: string,
  eventTitle: string,
  eventTypeId: number,
  calendarEventTypeName: string,
  nonAnnouncementProps?: {
    allowGiftCards: boolean;
    giftCardsUpdated: boolean;
    allowedGiftCardIds: number[];
    deliveryInstructions: string;
    dropoffLocation: string;
    emergencyContactInfo: string;
    numberRequired?: number;
    petCareTypeId?: number;
    pickupLocation: string;
  },
  announcementProps?: { announcementTypeId: number; sendEmailToPageFollowers: boolean }
) {
  const wasProvided = (value: string) => ((value?.length || 0) > 0).toString();

  const otherProps: IAnalyticsProps = {};
  if (nonAnnouncementProps) {
    otherProps.allowGiftCards = nonAnnouncementProps.allowGiftCards.toString();
    otherProps.giftCardsUpdated = nonAnnouncementProps.giftCardsUpdated.toString();
    otherProps.allowedGiftCardIds = nonAnnouncementProps.allowedGiftCardIds?.join(',') || '';
    otherProps.deliveryInstructionsProvided = wasProvided(nonAnnouncementProps.deliveryInstructions);
    otherProps.dropoffLocationProvided = wasProvided(nonAnnouncementProps.dropoffLocation);
    otherProps.emergencyContactInfoProvided = wasProvided(nonAnnouncementProps.emergencyContactInfo);
    otherProps.numberRequired = nonAnnouncementProps.numberRequired?.toString();
    otherProps.petCareTypeId = nonAnnouncementProps.petCareTypeId?.toString();
    otherProps.pickupLocationProvided = wasProvided(nonAnnouncementProps.pickupLocation);
  }
  if (announcementProps) {
    otherProps.announcementTypeId = announcementProps.announcementTypeId.toString();
    otherProps.sendEmailToPageFollowers = (announcementProps.sendEmailToPageFollowers || false).toString();
  }

  Analytics.fireEvent(
    analyticsEventName,
    {
      eventId,
      allDay: allDay.toString(),
      startsAt: startsAt,
      endsAt: endsAt || '',
      repeat: repeat || '',
      eventDescriptionProvided: wasProvided(eventDescription),
      eventTitleProvided: wasProvided(eventTitle),
      eventTypeId: eventTypeId.toString(),
      calendarEventType: calendarEventTypeName,
      ...otherProps,
    },
    actionKeys => actionKeys,
    _ => []
  );
}
